import { IconButton, Tooltip, useTheme } from "@mui/material";
import { Settings } from "@mui/icons-material";

import { Dispatch, SetStateAction } from "react";

export default function Config({
  setOpenConfig,
}: {
  setOpenConfig: Dispatch<SetStateAction<boolean>>;
}) {
  const theme = useTheme();
  const styles = {
    dotsIcon: {
      padding: "3px",
      fontSize: "29px",
      fill: theme.palette.text.primary,
      ":hover": { opacity: 1, transform: "rotate(90deg)" },
    },
  };
  return (
    <>
      <Tooltip title="Configurações Globais">
        <IconButton
          color="inherit"
          aria-label="notificacoes"
          onClick={() => {
            setOpenConfig(true);
          }}
        >
          <Settings sx={styles.dotsIcon} />
        </IconButton>
      </Tooltip>
    </>
  );
}
